import Vue from 'vue'
import {
  ACCOUNT_SHARING_LOGIN_NOTICE_BANNER_SELECTOR,
  ACCOUNT_SHARING_LOGIN_NOTICE_CTA_HASH,
  USETIFUL_CLOSE_BUTTON_SELECTOR,
  USETIFUL_OPEN_URL_ACTION_SELECTOR,
  containsAccountSharingCtaMarker,
  getUserId
} from '~/utils/accountSharingLoginNotice'

const LISTENER_INSTALLED_KEY = '__accountSharingLoginNoticeListenerInstalled'
const WATCHER_INSTALLED_KEY = '__accountSharingLoginNoticeWatcherInstalled'

function openChat(app) {
  const chat = (app && app.$chat) || Vue.prototype.$chat

  if (!chat) return

  if (typeof chat.open === 'function') {
    chat.open()
  }
}

function initializeUsetifulTags(app, user) {
  const userId = getUserId(user)
  const email = user && user.email

  if (!userId || !email) return false

  if (
    app &&
    app.$usetiful &&
    typeof app.$usetiful.usetifulTags === 'function'
  ) {
    app.$usetiful.usetifulTags(String(userId), 'USERS', email)
    return true
  }

  return false
}

export default ({ app, store }) => {
  if (!process.client || typeof window === 'undefined') return

  if (!window[LISTENER_INSTALLED_KEY]) {
    window[LISTENER_INSTALLED_KEY] = true
    document.addEventListener(
      'click',
      event => {
        const target = event && event.target
        if (!target || typeof target.closest !== 'function') return

        const banner = target.closest(
          ACCOUNT_SHARING_LOGIN_NOTICE_BANNER_SELECTOR
        )
        if (!banner) return

        const openUrlAction = target.closest(USETIFUL_OPEN_URL_ACTION_SELECTOR)
        if (
          openUrlAction &&
          banner.contains(openUrlAction) &&
          elementContainsAccountSharingMarker(openUrlAction)
        ) {
          event.preventDefault()
          event.stopPropagation()
          clearTalkToUsHash()
          openChat(app)
          return
        }

        const closeButton = target.closest(USETIFUL_CLOSE_BUTTON_SELECTOR)
        if (
          closeButton &&
          banner.contains(closeButton) &&
          bannerHasMarker(banner)
        ) {
          store.dispatch('accountSharingLoginNotice/dismiss')
        }
      },
      true
    )
  }

  /** @type {string | null} */
  let lastRefreshedUserId = null
  /** @type {string | null} */
  let lastTaggedUsetifulUserKey = null

  const refresh = user => {
    const userId = String(getUserId(user) || '')
    const email = (user && user.email) || ''
    const usetifulUserKey = userId && email ? `${userId}:${email}` : null

    if (
      usetifulUserKey &&
      usetifulUserKey !== lastTaggedUsetifulUserKey &&
      initializeUsetifulTags(app, user)
    ) {
      lastTaggedUsetifulUserKey = usetifulUserKey
    }

    if (userId !== lastRefreshedUserId) {
      lastRefreshedUserId = userId
      store.dispatch('accountSharingLoginNotice/refresh')
    }
  }

  refresh(app && app.$auth && app.$auth.user)

  if (
    !window[WATCHER_INSTALLED_KEY] &&
    store &&
    typeof store.watch === 'function'
  ) {
    window[WATCHER_INSTALLED_KEY] = true
    store.watch(state => state.auth && state.auth.user, refresh)
  }
}

function elementContainsAccountSharingMarker(element) {
  if (!element || typeof element.getAttribute !== 'function') return false

  const markerValues = [
    element.getAttribute('href'),
    element.getAttribute('value'),
    element.getAttribute('formaction'),
    ...Object.keys(element.dataset || {}).map(key => element.dataset[key])
  ]

  return markerValues.some(containsAccountSharingCtaMarker)
}

function bannerHasMarker(banner) {
  return Array.from(
    banner.querySelectorAll(USETIFUL_OPEN_URL_ACTION_SELECTOR)
  ).some(elementContainsAccountSharingMarker)
}

function clearTalkToUsHash() {
  if (window.location.hash !== ACCOUNT_SHARING_LOGIN_NOTICE_CTA_HASH) return

  window.history.replaceState(
    window.history.state,
    document.title,
    `${window.location.pathname}${window.location.search}`
  )
}
